<div class="cx-one-ui etl-data-feed-view-container mx-6">
    <cv-loader [loaderType]="'cxone'" *ngIf="showSpinner"></cv-loader>
    <div class="header-container" id="header-container">
        <div class="left-title-wrapper">
            <div class="breadCrumb" (click)="onBack()" cvLocalizedText langSection="ETL_Data_Feed_View" langKey="Data_Feed">Data Feed</div>
            <div class="pageTitle">{{pageHeader}}</div>
        </div>
        <button class="cxone-btn btn-big btn-secondary btn-bg-is-white" (click)="onBack()" cvLocalizedText langSection="ETL_Data_Feed_View" langKey="Back">Back</button>
    </div>
    <cxone-omnibar [itemCountLabel]="dataFeedViewLabel" [isFilterable]="false"
        [searchPlaceholderText]="searchPlaceholderText" (searchQueryChange)="onSearchCriteriaChange($event)"
        [searchQuery]="searchInput">
    </cxone-omnibar>
    <cxone-grid class="content-container" id="view-datafeed-grid" [columnDefs]="dataFeedViewGridHeaders"
        [rowData]="filteredDataFeedViewGridData" [gridOptions]="dataFeedViewGridOptions">
    </cxone-grid>
</div>